export default {"src":"/_next/static/media/products-telegramCommunity.8f376506.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};